module.exports = __webpack_public_path__ + "img/dealer-cup.f76b8428.svg";